import { FC } from "react";
import { Col } from "react-bootstrap";
import styled from "styled-components";
import Logo from "../assets/zoom-logo.png";

interface IPlayer {
  contentUrl: string;
}

const ZoomLogo = styled("img")({
  width: "140px",
  height: "31.5px",
});

const ZoomWrapper = styled(Col)({
  padding: "32px 16px",
  backgroundColor: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  height: "calc(100% - 22px)",
  flexFlow: "column",
});

const JoinInNativeAppLink = styled("a")({
  backgroundColor: "#2D8CFF",
  borderColor: "#2D8CFF",
  padding: "6px 20px",
  textAlign: "center",
  margin: "10px 0",
  transition: ".3s ease",
  display: "table",
  textDecoration: "none",
  marginTop: "32px",
  color: "#ffffff",
  borderRadius: "3px",
  border: "2px solid #2D8CFF",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "rgb(45, 165, 255)",
    color: "#ffffff",
  },
});

const ZoomPlayer: FC<IPlayer> = ({ contentUrl }) => {
  return (
    <ZoomWrapper md={12}>
      <ZoomLogo src={Logo} alt="Zoom Logo" width="300" />
      <JoinInNativeAppLink href={contentUrl} target="_blank">
        For the best experience, watch this event in the Zoom app
      </JoinInNativeAppLink>
    </ZoomWrapper>
  );
};

export default ZoomPlayer;
